import { styled } from 'styled-components';

import ChooseColor from './ChooseColor';

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  align-self: center;

  margin: 10pt;
  margin-top: 5rem;
  margin-bottom: 10rem;
  padding: 10pt;

  width: 30%;
  min-height: 0;

  border: 2pt solid gray;

  font-size: 32pt;

  color: #0000ff;

  z-index: 5;

  background-color: #c0c0c0;

  // drop shadow
  box-shadow: 0pt 4pt 4pt 0 rgba(0, 0, 0, 0.5);

  @media only screen and (max-width: 1280px) {
    margin-top: 10 rem;
    width: 80%;
    margin-bottom: 4rem;
  }

  a {
    padding: 4pt;
    font-size: 3rem;
    cursor: pointer;

    border: 2pt solid gray;

    &:hover {
      color: #ff0000;
    }
  }
`;

type Props = {
  gameId: string;
};

export default function ChooseColorPanel(props: Props) {
  return (
    <Container>
      Choose Color
      <ChooseColor gameId={props.gameId} />
    </Container>
  );
}
